module.exports = __webpack_public_path__ + "img/5.90d35804.png";